"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _index = require("../../../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var HiddenCheckbox = _styled["default"].input(_index.everything);
HiddenCheckbox.defaultProps = {
  display: 'none',
  type: 'checkbox'
};
var _default = HiddenCheckbox;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJIaWRkZW5DaGVja2JveCIsInN0eWxlZCIsImlucHV0IiwiZXZlcnl0aGluZyIsImRlZmF1bHRQcm9wcyIsImRpc3BsYXkiLCJ0eXBlIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvZm9ybS9Ub2dnbGUvSGlkZGVuQ2hlY2tib3gudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBldmVyeXRoaW5nIH0gZnJvbSAnLi4vLi4vLi4vaW5kZXgnO1xuXG5jb25zdCBIaWRkZW5DaGVja2JveCA9IHN0eWxlZC5pbnB1dChldmVyeXRoaW5nKTtcblxuSGlkZGVuQ2hlY2tib3guZGVmYXVsdFByb3BzID0ge1xuICBkaXNwbGF5OiAnbm9uZScsXG4gIHR5cGU6ICdjaGVja2JveCcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBIaWRkZW5DaGVja2JveDtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7QUFFQTtBQUE0QztBQUU1QyxJQUFNQSxjQUFjLEdBQUdDLGtCQUFNLENBQUNDLEtBQUssQ0FBQ0MsaUJBQVUsQ0FBQztBQUUvQ0gsY0FBYyxDQUFDSSxZQUFZLEdBQUc7RUFDNUJDLE9BQU8sRUFBRSxNQUFNO0VBQ2ZDLElBQUksRUFBRTtBQUNSLENBQUM7QUFBQyxlQUVhTixjQUFjO0FBQUEifQ==